import React from "react"

import {useTranslations} from "@cirrus/core/i18n/provider"
import {styled} from "@cirrus/ui-kit/src/lib/_public"

import {useTableContext} from "../../provider"
import {ProgressColumnType} from "../TableColumns/state"
import {LeftProgressCell, PercentageProgressCell} from "../ProgressCell"

const StyledFooter = styled("div")({
  position: "relative",
  width: "100%",
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  height: "40px",

  "& > div": {
    height: "30px",
    padding: "0 16px",
    display: "flex",
    alignItems: "center",
  },

  "& > div:first-child": {
    fontWeight: "bold",
    width: "15%",
    textTransform: "uppercase"
  },

  "& > div:nth-child(2)": {
    fontWeight: "bold",
    width: "70%",
    position: "relative",
  },

  "& > div:last-child": {
    fontWeight: ({ isCompleted }) => isCompleted ? "bold" : "normal",
    color: ({ isCompleted }) => isCompleted ? "rgba(51, 159, 122, 1)" : "inherit",
  }
})

export const ProgressTableFooter = () => {
  const {i18n} = useTranslations()
  const ctx = useTableContext()
  const {props: { progressType, totalProgress}} = ctx
  const {percentage, total, submitted} = totalProgress || {total: 0, submitted: 0}
  const left = total - submitted

  return (
    <StyledFooter isCompleted={left === 0}>
      <div>{i18n("General:Total")}</div>
      <div>

        {progressType === ProgressColumnType.PERCENTAGE && (
          <PercentageProgressCell percentage={percentage || ""} />
        )}

        {progressType === ProgressColumnType.COUNT && (
          <LeftProgressCell
            maxTotal={total || 0}
            left={left}
            total={total || 0}
          />
        )}

      </div>
      <div>
        {progressType === ProgressColumnType.COUNT && total}
      </div>
    </StyledFooter>
  )
}